import { render, staticRenderFns } from "./product-distribution-by-province.vue?vue&type=template&id=073e7ff0&scoped=true"
import script from "./product-distribution-by-province.vue?vue&type=script&lang=js"
export * from "./product-distribution-by-province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e7ff0",
  null
  
)

export default component.exports